
const meRoutes = [
    {
        path:'info/:user_id',
        name:'me-info',
        component: () => import(/* webpackChunkName: "about" */ '@/views/me/info.vue')
    },
    {
        path: 'subscribe',
        name:'me-subscribe',
        component: () => import(/* webpackChunkName: "about" */ '@/views/me/subscribe.vue')
    },
    {
        path: 'setting',
        name:'me-setting',
        component: () => import(/* webpackChunkName: "about" */ '@/views/me/setting.vue')
    }
]
export default meRoutes